module.exports = __webpack_public_path__ + "static/media/blom-pysanky-95.3969d06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-95.jpg
// module id = 3789
// module chunks = 13